/**
 * Признак «на этом устройстве у ученика уже были записи «Недавно добавленных»» (ТЗ главной § 22.8):
 * `localStorage['lx.generations.seen.<userId>'] = '1'`. С ним секция при загрузке рисует скелетон,
 * а при ошибке — строку с «Повторить»; без него — ничего, и у кого записей нет, секция не мигнёт.
 * Ставит и снимает секция (§ 23.4, п. 3). Хранилище передаётся аргументом, все обращения — в
 * try/catch: без хранилища (приватный режим, запрет) признака просто нет. Без alias-импортов.
 */

export interface SeenStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export const generationsSeenKey = (userId: string) => `lx.generations.seen.${userId}`;

function browserStore(): SeenStore | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function readGenerationsSeen(userId: string | null | undefined, store: SeenStore | null = browserStore()): boolean {
  if (!store || !userId) return false;
  try {
    return store.getItem(generationsSeenKey(userId)) === '1';
  } catch {
    return false;
  }
}

/** Ставит (`seen`) или снимает признак; ошибка хранилища ничего не роняет. */
export function writeGenerationsSeen(
  userId: string | null | undefined,
  seen: boolean,
  store: SeenStore | null = browserStore(),
): void {
  if (!store || !userId) return;
  try {
    if (seen) store.setItem(generationsSeenKey(userId), '1');
    else store.removeItem(generationsSeenKey(userId));
  } catch {
    // Хранилище недоступно или переполнено — признака нет, секция работает и без него.
  }
}
